import moment from "moment";
import { IS_DEV } from "../config";
import NumberFormat from "vue-currency-input/src/numberFormat";
import { documentFormats } from "@/utils/constants";
import Cookies from "universal-cookie";

const cookies = new Cookies(null);

const options = {
  path: "/",
};
if (!IS_DEV) options.domain = "dt.uz";

const numberFormat = new NumberFormat({});

export function generateText(wordCount = 10) {
  let text = "";
  let alphabet =
    "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,r,s,t,u,v,w,x,y,z".split(
      ","
    );
  for (let i = 0; i < wordCount; i++) {
    let rand = Math.floor(Math.random() * alphabet.length);
    text += alphabet[rand];
  }
  return text;
}

export function getLanguageFromLocalStorage(
  key = "lang",
  defaultLanguage = "ru"
) {
  function getLanguagePreference() {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [name, value] = cookie.split("=");
      if (name === key) {
        return value;
      }
    }
  }
  const lang = getLanguagePreference();

  return lang || defaultLanguage;
}

export function setLanguageToLocalStorage(lang = "ru", key = "lang") {
  if (!lang) throw new Error("language not setting");
  cookies.set(key, lang, options);
}

export function debounce(fn, delay) {
  let timeout = null;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

export function parsePhoneFormat(value) {
  /**
   * ! format must be short || full
   */

  return {
    format(format, prefix = "998") {
      if (format === "short") {
        value = value?.split(/(\+?\d{3})/);
        value?.shift();
        value?.shift(); // prefix remove
        return value?.join("");
      } else if (format === "full") {
        value = value?.replace(/[()-]/g, "");
        return prefix + value;
      }
      return value;
    },
  };
}

export const makerPagination = ({ limit, total }) => {
  return {
    limit,
    total,
    lastPage: Math.ceil(total / limit),
  };
};

export const isValidDate = (date) => {
  return !isNaN(new Date(date).getTime());
};

export const isNaNNumber = (value) => {
  if (!value) return false;
  if (typeof value === "number") return true;
  value = value.trim();
  return Number.isNaN(parseInt(value));
};

export const trueSet = (val) => {
  if (typeof val === "boolean") return val;
  if (typeof val === "string") return val.toLowerCase() === "true";
};

export const timeToISOString = (date) => {
  if (!isValidDate(date)) return null;
  return moment(date)
    .subtract(new Date().getTimezoneOffset(), "minutes")
    .toISOString()
    .substr(0, 10);
};

export const getKeys = (obj) => {
  if (typeof obj === "object" && !Array.isArray(obj)) {
    return Object.keys(obj);
  }
  return [];
};

export const dateParse = (val) => {
  if (!val) return "";
  return moment(new Date(val))
    .subtract(new Date().getTimezoneOffset() / 60, "hours")
    .format("DD/MM/YYYY");
};
export const dateParseToString = (val) => {
  if (!val) return "";
  let lang = getLanguageFromLocalStorage();
  if (lang === "cyrl") lang = "uz";
  if (lang === "uz") lang = "uz-latn";
  return moment(new Date(val))
    .subtract(new Date().getTimezoneOffset() / 60, "hours")
    .locale(lang)
    .format("MMMM Do YYYY");
};

export const addTimeZone = (val) => {
  if (!val) return "";
  return moment(new Date(val))
    .subtract(new Date().getTimezoneOffset() / 60, "hours")
    .toDate();
};

export const dateToLocalString = (time) => {
  if (!time) return null;
  const date = new Date(time);
  const year = date.getFullYear();
  const day = date.getDate();
  const months = date.getMonth() + 1;

  function pad(num) {
    if (num < 10) {
      return `0${num}`;
    }
    return num;
  }

  return `${pad(day)}/${pad(months)}/${year}`;
};

export const fullTimeParse = (val) => {
  if (!val) return "";
  return moment(new Date(val))
    .subtract(new Date().getTimezoneOffset() / 60, "hours")
    .format("DD/MM/YYYY HH:mm");
};

export const getValueByKey = (obj, obj2) => {
  let objWithValue = {};
  getKeys(obj).forEach((item) => {
    if (obj2[item]) {
      objWithValue[item] = obj2[item];
    } else {
      objWithValue[item] = obj[item];
    }
  });
  return objWithValue;
};

export const numberParse = (val) => {
  if (!val) return "";
  return numberFormat.format(val);
};

export const queryToString = (obj) => {
  let query = "?";
  const addQuery = (key, value) => {
    if (value) {
      if (typeof value === "string") value = value.replace("+", "%2B");
      query += `${key}=${value}&`;
    }
  };
  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        addQuery(key, item);
      });
    } else {
      addQuery(key, value);
    }
  });
  return query.substring(0, query.length - 1);
};

export const downloadBlobFile = (blob, fileName = "file") => {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.style.display = "none";
  const url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
};

export const markText = (searchText, text) => {
  const query = new RegExp(searchText, "gi");
  return text.replace(query, (a) => {
    return `<span class="v-list-item__mask">${a}</span>`;
  });
};

export const filterProduct = (item, queryText) => {
  const query = new RegExp(queryText, "i");
  return !!item.name.match(query) || !!item.attrs.join("").match(query);
};

export const specialAbilityState = {
  get(key) {
    return localStorage.getItem(key);
  },
  set(key, value) {
    localStorage.setItem(key, value);
  },
};

export const getQueryByKey = (obj, query) => {
  const item = {};
  Object.keys(obj).forEach((prop) => {
    if (query[prop] !== null && typeof query[prop] !== "undefined") {
      item[prop] = query[prop];
    } else {
      item[prop] = obj[prop];
    }
  });
  return item;
};

export const addTimeZoneToISOString = () => {
  (function () {
    function pad(number) {
      if (number < 10) {
        return "0" + number;
      }
      return number.toString();
    }

    function getTimeZone() {
      return Math.ceil(Math.abs(new Date().getTimezoneOffset()) / 60);
    }

    Date.prototype.toISOStringWithTimeZone = function (startDay = true) {
      const timeZoneOffset = this.getTimezoneOffset() > 0 ? "-" : "+";
      return `${this.getUTCFullYear()}-${pad(this.getUTCMonth() + 1)}-${pad(
        this.getUTCDate()
      )}T${startDay ? pad(this.getUTCHours()) : 23}:${
        startDay ? pad(this.getUTCMinutes()) : 59
      }:${startDay ? pad(this.getUTCSeconds()) : 59}${timeZoneOffset}${pad(
        getTimeZone()
      )}00`;
    };
  })();
};

export const isISOSTime = (date) => {
  return date.toString().length === 24;
};

export const cipher = (salt) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const byteHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
  const applySaltToChar = (code) =>
    textToChars(salt).reduce((a, b) => a ^ b, code);

  return (text) =>
    text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};
export const decipher = (salt) => {
  const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
  const applySaltToChar = (code) =>
    textToChars(salt).reduce((a, b) => a ^ b, code);
  return (encoded) =>
    encoded
      .match(/.{1,2}/g)
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join("");
};

export const shallowEqual = (object1, object2) => {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (let key of keys1) {
    if (object1[key] !== object2[key]) {
      return false;
    }
  }
  return true;
};

export const clearSelection = () => {
  if (window.getSelection) {
    window.getSelection().removeAllRanges();
  } else if (document.selection) {
    document.selection.empty();
  }
};

export const isFileDocument = (file) => {
  return documentFormats.includes(file.type);
};

export const blobToUrl = async (blob) => {
  return new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.readAsDataURL(blob);
  });
};

export const insertDataToFormData = (data) => {
  const formData = new FormData();
  Object.entries(data).forEach(
    /**
     * @param prop {string}
     * @param value {(string|File)}
     */
    ([prop, value]) => {
      formData.append(prop, value);
    }
  );
  return formData;
};

insertDataToFormData({
  file: new Blob(),
});

export const prepareBase64 = (urls) => {
  const basePrefix = "data:application/octet-stream;base64,";
  return urls.map((url) => basePrefix + url);
};

export const getQueryPage = (page, currentPage = 1) => {
  if (page && !isNaN(page)) return parseInt(page);
  return currentPage;
};

export const setUnitSize = (unit, defaultUnitType = "px") => {
  if (typeof unit === "number" || !isNaN(unit))
    return `${unit}${defaultUnitType}`;
  return unit;
};

/**
 *
 * @param {string} text
 * @param {number} maxTextSize
 * @returns {string[]}
 */
export function chunkText(text, maxTextSize) {
  if (text.length <= maxTextSize) return [text];
  let texts = [];
  const piece = Math.ceil(text.length / maxTextSize);
  for (let i = 0; i < piece; i++) {
    texts.push(text.substr(i * maxTextSize, maxTextSize));
  }
  return texts;
}

export function fullTrim(str) {
  // Use a regular expression to remove all spaces from the string
  return str.replace(/\s/g, "");
}

export function formDataMaker({ ...obj }) {
  const formData = new FormData();
  for (let key in obj) {
    formData.append(key, obj[key]);
  }

  return formData;
}
